<template>
  <div>
    <my-popup
      title="插入短链接网址"
      width="582"
      :flag="insertShortUrlShow"
      @close="cancel"
    >
      <div class="tab-line">
        <div
          class="tab-item"
          :style="{
            color: switchType == '0' ? globalBG : '',
            'background-color': switchType == '0' ? '#FFF4F4' : '',
            'border-color': switchType == '0' ? globalBG : '',
          }"
          @click="switchTab('0')"
        >
          网址
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '1' ? globalBG : '',
            'background-color': switchType == '1' ? '#FFF4F4' : '',
            'border-color': switchType == '1' ? globalBG : '',
          }"
          @click="switchTab('1')"
        >
          店铺首页
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '2' ? globalBG : '',
            'background-color': switchType == '2' ? '#FFF4F4' : '',
            'border-color': switchType == '2' ? globalBG : '',
          }"
          @click="switchTab('2')"
        >
          商品链接
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '3' ? globalBG : '',
            'background-color': switchType == '3' ? '#FFF4F4' : '',
            'border-color': switchType == '3' ? globalBG : '',
          }"
          @click="switchTab('3')"
        >
          优惠券
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '4' ? globalBG : '',
            'background-color': switchType == '4' ? '#FFF4F4' : '',
            'border-color': switchType == '4' ? globalBG : '',
          }"
          @click="switchTab('4')"
        >
          其他页面
        </div>
      </div>
      <div class="insertBox" v-if="switchType == 0">
        <div class="inser">
          <span>网址：</span>
          <!-- <el-input v-model="insertUrlValue" placeholder="仅支持手机端京东域名链接，如m.jd" style="width: 480px;"></el-input> -->
          <el-input
            v-model="insertUrlValue"
            placeholder="请输入http://开头的链接"
            style="width: 480px;"
          ></el-input>
        </div>
        <div class="tip_box">
                                      <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            position: absolute;
                            height: 14px;
                            color: #ffffff;
                                margin: 4px 0 0 -12px;
                          "
                        />
          <div>
            （1）仅支持手机端京东域名链接，如m.jd，且短信中只能插入一条短链；
          </div>
          <div>
            （2）发送测试短信不受发送时间限制，点击发送后，测试短信立即发送
          </div>
          <div>
            （3）手机端京东其它活动页面（如开卡页面）需打开APP请使用“其它页面”功能进行转短网址。
          </div>
        </div>
        <el-button class="cancelBtn" type="text" @click="cancel"
          >取消</el-button
        >
        <button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(1)"
        >
          确定
        </button>
      </div>
      <div class="insertBox" v-if="switchType == 1">
        <div class="inser">
          <span style="width: 42px">网址：</span>
          <!-- <el-input
            v-model="insertUrlValue"
            placeholder="仅支持手机端京东域名链接，如m.jd"
            style="width: 480px;"
          ></el-input> -->
          <el-input
            v-model="insertUrlValue"
            placeholder="https://mall.jd.com/index-10094518.html"
            style="width: 480px;"
          ></el-input>
        </div>
        <div class="tip_box">
             <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            position: absolute;
                            height: 14px;
                            color: #ffffff;
                                margin: 4px 0 0 -12px;
                          "
                        />
          <div>
            （1）跳转京东APP；
          </div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          v-loading="loading"
          @click="cancel"
          >取消</el-button
        >
        <button class="createUrlBtn" @click="insertUrlChange(2)">确定</button>
      </div>
      <div class="insertBox" v-if="switchType == 2">
        <div class="inser">
          <span style="width: 80px">SKU ID：</span>
          <el-input
            v-model="insertUrlValue"
            oninput="value=value.replace(/^\.+|[^\d]/g,'')"
            placeholder="请输入商品SKU ID"
            style="width: 480px;"
          ></el-input>
        </div>
        <div class="tip_box">
             <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            position: absolute;
                            height: 14px;
                            color: #ffffff;
                                margin: 4px 0 0 -12px;
                          "
                        />
          <div>
            （1）跳转京东APP；
          </div>
        </div>
        <el-button class="cancelBtn" type="text" @click="cancel"
          >取消</el-button
        >
        <button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(3)"
        >
          确定
        </button>
      </div>
      <div class="insertBox" v-if="switchType == 3">
        <div class="insert">
          <div class="insert-name" style="width:90px">优惠券地址：</div>
          <div class="insert-value">
            <el-button
              type="primary"
              @click="insertCouponShow = true"
              style="margin-bottom: 16px"
              :style="{ 'background-color': globalBG }"
              >选择优惠券</el-button
            >
            <el-input
              v-model="insertUrlValue"
              type="textarea"
              rows="4"
              placeholder="请输入商品SKU ID"
              style="width: 430px;"
            ></el-input>
          </div>
        </div>
        <el-button class="cancelBtn" type="text" @click="cancel"
          >取消</el-button
        >
        <button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(4)"
        >
          确定
        </button>
      </div>
      <div class="insertBox" v-if="switchType == 4">
        <div class="inser">
          <span>网址：</span>
          <el-input
            v-model="insertUrlValue"
            placeholder="仅支持手机端京东域名链接，如m.jd"
            style="width: 480px;"
          ></el-input>
        </div>
        <div class="tip_box">
             <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            position: absolute;
                            height: 14px;
                            color: #ffffff;
                                margin: 4px 0 0 -12px;
                          "
                        />
          <div>
            （1）仅支持手机端京东域名链接，如m.jd，且短信中只能插入一条短链；
          </div>
          <!-- 
          <div>
            （2）发送测试短信不受发送时间限制，点击发送后，测试短信立即发送
          </div>
          <div>
            （3）手机端京东其它活动页面（如开卡页面）需打开APP请使用“其它页面”功能进行转短网址。
          </div> -->
          <div>
            （2）默认短链前后添加空格，不可删除，保证点击跳转正常。
          </div>
          <div>
            （3）跳转京东APP
          </div>
        </div>
        <el-button class="cancelBtn" type="text" @click="cancel"
          >取消</el-button
        >
        <button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(1)"
        >
          确定
        </button>
      </div>
    </my-popup>

    <!-- 插入优惠券链接 -->
    <insert-coupon-link
      v-if="insertCouponShow"
      :isShow="insertCouponShow"
      @close="insertCouponChange"
    ></insert-coupon-link>
  </div>
</template>
<script>
import myPopup from "@/components/myPopup";
import insertCouponLink from "@/views/serviceCenter/insert_coupon_link";
import { getShortLink } from "@/api/marketing/shortLink";
import { mapState } from "vuex";
export default {
  // 插入短网址弹窗
  name: "",
  components: {
    myPopup,
    insertCouponLink,
  },
  props: {
    typeSms: {
      type: Number,
      default: 2, // 1.表示智能营销 2.官方发送， 3.平台发送
    },
  },
  data() {
    return {
      insertShortUrlShow: true, // 插入短链接状态控制 ----- 内容
      insertUrlValue: null, // 插入网址
      switchType: 0,
      insertCouponShow: false, // 插入优惠券链接控制
      loading: false,
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  mounted() {
    this.show = true;
  },
  methods: {
    cancel() {
      // this.insertShortUrlShow = false;
      this.$emit("close", false);
    },
    switchTab(index) {
      this.insertUrlValue = null;
      this.switchType = index;
    },
    insertCouponChange(val, item) {
      this.insertCouponShow = false;
      console.log("插入优惠劵返回==", val, item);
      if (val == true) {
        this.insertUrlValue = item.link;
      }
    },
    // 插入短链接隐藏
    insertUrlChange(val) {
      let params = {
        isJdApi: 2,
        url: this.insertUrlValue,
        shortLinkType: val,
        isSmartLink: 0,
        isPrecision: 0,
      };
      this.loading = true;
      getShortLink(params)
        .then((res) => {
          this.$emit("close", false, res.data.shortLink,params.url);
          this.insertUrlValue = null;
          this.loading = false;
          this.$message.success(res.message);
        })
        .catch((err) => {
          this.$message.error("仅支持京东无线域名链接，如.m.jd、m.yiyaojd、mitem.jkcsjd、mitem.jd，请重新输入")
          this.loading = false
        });
        this.$emit("insertUrlValues",this.insertUrlValue)
    },
  },
};
</script>
<style lang="scss" scoped>
.insertBox {
  text-align: right;
  .inser {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .insert {
    text-align: left;
    margin-top: 20px;
    .insert-name {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      vertical-align: text-top;
      line-height: 32px;
    }
    .insert-value {
      display: inline-block;
      width: 400px;
      vertical-align: text-top;
    }
  }
  .cancelBtn {
    margin-right: 10px;
    color: #666666;
border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
  }
  .createUrlBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
    border: 1px solid #fe4d45;
     &:hover{
      color: #fff ;
      opacity: 0.9;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
    }
  &:active {
    color: #fff ;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
  }
  }
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 3px;
  }
  .tip_box {
    padding-left: 24px;
    text-align: left;
    line-height: 21px;
    font-size: 14px;
    margin-top: 12px;
    color: #999999;
    position: relative;
    .warning-icon {
      color: #fe8f8a;
      font-size: 14px;
      position: absolute;
      left: 5px;
      top: 4px;
    }
  }
}

.tab-line {
  .tab-item {
    display: inline-block;
    width: 80px;
    line-height: 32px;
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    text-align: center;
    border-radius: 4px;
    margin-top: 20px;
    cursor: pointer;
    margin-right: 8px;
    font-size: 14px;
    color: #333;
  }
}
</style>
